import { css } from 'styled-components'
import bgBlur from 'styles/bgBlur'
import { default as itemDisabled } from 'styles/disabled'
import type { NumberRange } from 'types/utils'
import type { StyledFunction } from 'types/style'
import colors from 'utils/styling/colors'

export type DecorationProps = {
  opacity?: string | number
  radius?: string
  background?: string
  backgroundColor?: string
  bgOpacity?: NumberRange<0, 100>
  clickable?: boolean | number
  clickThrough?: boolean
  pointerEvents?: 'none' | 'auto' | 'all' | 'inherit' | 'initial'
  blur?: boolean
  overflow?: string
  transition?: string
  disabled?: boolean
  shadow?: string
  translateY?: string
  translateX?: string
  scale?: number
  transformOrigin?: string
}

const getTransform = (
  translateX?: string,
  translateY?: string,
  scale?: number,
): string => {
  if (scale) return `scale(${scale})`
  if (translateX && translateY) return `translate(${translateX}, ${translateY})`
  if (translateX) return `translateX(${translateX})`
  return `translateY(${translateY})` // ensure backwards compatibility, return same value as before this change
}

export const decorations: StyledFunction<DecorationProps> = ({
  opacity,
  radius,
  background = '',
  backgroundColor = '',
  bgOpacity = undefined,
  clickable,
  clickThrough,
  pointerEvents,
  blur,
  overflow,
  transition,
  disabled,
  shadow,
  translateY,
  translateX,
  scale,
  transformOrigin,
}) => css`
  opacity: ${opacity};
  transform: ${getTransform(translateX, translateY, scale)};
  ${transformOrigin && `transform-origin: ${transformOrigin};`}
  border-radius: ${radius};
  background: ${colors(background, bgOpacity)};
  background-color: ${colors(backgroundColor, bgOpacity)};
  cursor: ${clickable && `pointer`};
  pointer-events: ${pointerEvents || (clickThrough && `none`)};
  transition: background-color 0.25s;
  overflow: ${overflow};
  transition: ${transition};
  box-shadow: ${shadow};
  ${blur && bgBlur}
  ${disabled && itemDisabled};
`

export default decorations
